import * as React from "react";
import { forwardRef } from "react";
const SvgDot = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-dot-icon lucide-dot", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 12.1, cy: 12.1, r: 2.5 }));
const ForwardRef = forwardRef(SvgDot);
export default ForwardRef;
